import React from 'react'

function TileArticlePlaceholder () {
  return (
    <div className="tile-article-placeholder">
      <div className="tile-article-placeholder__hero" />
      <div className="tile-article-placeholder__text" />
      <div className="tile-article-placeholder__text" />
    </div>
  )
}

export default TileArticlePlaceholder
